import { memo, useEffect, useState, useRef } from "react";
import ModalComponent from "@zenith/components/ui/ModalComponent/modal-component/modal-component";
import {
  SERVICE_MODAL_BODY,
  SERVICE_MODAL_TITLE,
} from "@zenith/data/constants";
import { useServiceFailureContext } from "@zenith/context/global-context/hooks";
import { ServiceFailure } from "@zenith/services";
import axios, { AxiosRequestConfig } from "axios";

const ServiceFailureComponent = memo(function ServiceFailureComponent() {
  const [showModal, setShowModal] = useState(false);
  const {
    serviceFailureContext: { hasError },
    setServiceFailureContext,
  } = useServiceFailureContext();

  const lastRequestRef = useRef<null | AxiosRequestConfig>(null);

  useEffect(() => {
    setShowModal(hasError);
  }, [hasError]);

  const retryRequest = async () => {
    const lastRequest: AxiosRequestConfig | null = lastRequestRef.current;

    if (lastRequest) {
      try {
        const response = await axios(lastRequest); // Retry the last failed request
        return response;
      } catch (error) {
        console.error("Retry failed:", error);
      }
    }
  };


  const handleTryAgain = () => {
    retryRequest();
    setServiceFailureContext(false);
  };

  return (
    <ServiceFailure lastRequestRef={lastRequestRef}>
      <ModalComponent
        title={SERVICE_MODAL_TITLE}
        body={SERVICE_MODAL_BODY}
        showModal={showModal}
        onClickButton={handleTryAgain}
        onClickClose={() => setServiceFailureContext(false)}
        buttonText="Try again"
      />
    </ServiceFailure>
  );
});

export default ServiceFailureComponent;
